// extracted by mini-css-extract-plugin
export default {"wrapper":"sFRVAb4","bidRange":"mEItuGg"};